import { useCallback, useState } from "react";

export const useForm = (initialState = {}, fieldValidations = {}) => {
   const [inputValues, setInputValues] = useState(initialState);
   const [fieldErrors, setFieldErrors] = useState({});

   const handleInputOnChange = useCallback(({ target }, active = null, uppercase = false) => {
      const { name, value } = target;
      const maxLength = fieldValidations[name]?.maxLength;
      const minLength = fieldValidations[name]?.minLength;
      const message = fieldValidations[name]?.message;

      if (fieldValidations[name]?.required && value.trim() === '') {
         setFieldErrors({
            ...fieldErrors,
            [name]: "* Este campo es requerido"
         });
      } else if (minLength && value.length > 0 && value.length < minLength) {
         setFieldErrors({
            ...fieldErrors,
            [name]: `* Deben ser al menos ${minLength} caracteres`
         });
      } else if (value.length >= 0 && value.length < maxLength) {
         setFieldErrors({
            ...fieldErrors,
            [name]: message
         });
      } else {
         setFieldErrors({
            ...fieldErrors,
            [name]: ""
         });
      }

      const stopInput = maxLength ? value.substring(0, maxLength) : value;

      setInputValues({
         ...inputValues,
         [name]: uppercase ? stopInput.toUpperCase() : stopInput
      });

      if (active) {
         setInputValues({
            ...inputValues,
            [target.name]: target.value
         });
      }
   }, [inputValues]);

   const cleanForm = () => {
      setInputValues(initialState);
      setFieldErrors({});
   };

   const handleNewValues = (values) => {
      setInputValues(prev => ({
         ...prev,
         ...values
      }));
      setFieldErrors({})
   };

   const handleInputAutoComplete = (e, v) => {
      e.preventDefault()
      setInputValues({
         ...inputValues,
         [e.target.name]: v
      });
   }

   const runValidates = (optionalFields = []) => {
      const newFieldErrors = {};

      for (const fieldName in fieldValidations) {
         if (fieldValidations[fieldName].required && !inputValues[fieldName] && !optionalFields.includes(fieldName)) {
            newFieldErrors[fieldName] = "* Este campo es requerido";
         }
      }

      setFieldErrors(newFieldErrors);
      return Object.keys(newFieldErrors).length > 0;
   };

   return { 
      inputValues, 
      fieldErrors, 
      handleInputOnChange,
      handleInputAutoComplete, 
      cleanForm, 
      handleNewValues, 
      setFieldErrors, 
      runValidates
    };
};
